import { render, staticRenderFns } from "./ApprovalProject.vue?vue&type=template&id=2499914c&scoped=true"
import script from "./ApprovalProject.vue?vue&type=script&lang=js"
export * from "./ApprovalProject.vue?vue&type=script&lang=js"
import style0 from "./ApprovalProject.vue?vue&type=style&index=0&id=2499914c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2499914c",
  null
  
)

export default component.exports